export default __webpack_public_path__ + "static/media/mobile-outline-16px.c17e9f88.svg";